import {Button} from "antd";
import WrappedPre from "../util/WrappedPre";
import React, {useEffect, useState} from "react";
import useCopy from "../hooks/useCopy";
import {INTERESTING_EXIF_SECTIONS} from "../constants";

const ImageFilteredExifSection = ({exifInfo}) => {

    const [filteredText, setFilteredText] = useState();

    useEffect(() => {
        if (exifInfo && exifInfo.text) {
            const filtered = exifInfo.text.split('\n').filter(line => {
                let contains = false;
                INTERESTING_EXIF_SECTIONS.forEach(filter => {
                    contains =
                        contains ||
                        (line.includes(`[${filter.section}]`) &&
                            (filter.heading === '*' || line.includes(filter.heading)));
                });
                return contains;
            }).join('\n');
            setFilteredText(filtered);
        }
    }, [exifInfo])

    const {copyValue} = useCopy();
    return (<React.Fragment>
        {filteredText && <React.Fragment>
            <div className="exif-section-heading">
                <h2>Most relevant exif</h2>
                <Button onClick={() => copyValue(filteredText)}>
                    Copy
                </Button>
            </div>
            <div style={{position: 'relative'}}>

                <WrappedPre style={{overflowY: 'scroll', maxHeight: '300px'}}>{filteredText}</WrappedPre>
            </div>
        </React.Fragment>}
    </React.Fragment>);
}

export default ImageFilteredExifSection;


// WEBPACK FOOTER //
// ./src/exif/ImageFilteredExifSection.js